var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67673 16.1069C8.79666 15.9841 8.8638 15.8193 8.8638 15.6476C8.8638 15.476 8.79666 15.3112 8.67673 15.1884L1.97635 8.31474L8.67673 1.44249C8.79666 1.31971 8.8638 1.15488 8.8638 0.983241C8.8638 0.811604 8.79666 0.646774 8.67673 0.52399C8.61843 0.464118 8.54873 0.416531 8.47174 0.384037C8.39476 0.351544 8.31204 0.334805 8.22848 0.334805C8.14491 0.334805 8.06219 0.351544 7.98521 0.384037C7.90822 0.416531 7.83852 0.464118 7.78023 0.52399L0.654977 7.83487C0.529833 7.96326 0.459793 8.13545 0.459793 8.31474C0.459793 8.49403 0.529833 8.66623 0.654977 8.79462L7.78023 16.1055C7.83852 16.1654 7.90822 16.213 7.98521 16.2454C8.0622 16.2779 8.14491 16.2947 8.22848 16.2947C8.31204 16.2947 8.39476 16.2779 8.47175 16.2454C8.54873 16.213 8.61843 16.1654 8.67673 16.1055L8.67673 16.1069Z",
    fill: "#EE7734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5c3035d7f5774fc16ac66406eb11e084.svg";
export { ForwardRef as ReactComponent };